import { REQUEST_START, REQUEST_FINISH } from '../actions/actionTypes';

export default interface FetchingState {
  loading: number
}; 

const initialState: FetchingState = {
  loading: 0
};

export const fetchingReducer = (state: FetchingState = initialState, action: any) => {

  switch (action.type) {
    case REQUEST_START:
      return { ...state, loading: state.loading + 1 };
    case REQUEST_FINISH:
      return { ...state, loading: state.loading - 1 };
    default:
     return state;
  };
};
